import './instrument';
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'leaflet/dist/leaflet.css';
import './index.css';
import App from './App';
import { Capacitor } from '@capacitor/core';
import { hydrateAuthTokens } from './utils/authStorage';
import * as Sentry from '@sentry/react';
import { sentryEnabled } from './instrument';
import { FriendlyErrorFallback } from './components/FriendlyErrorFallback';

console.log('🚀 App starting...');
console.log('📱 Is Native Platform:', Capacitor.isNativePlatform());
console.log('🌐 Platform:', Capacitor.getPlatform());

if (Capacitor.isNativePlatform()) {
  document.documentElement.classList.add('capacitor-native');
  document.documentElement.classList.add(`platform-${Capacitor.getPlatform()}`);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

void hydrateAuthTokens()
  .catch(() => undefined)
  .finally(() => {
    const app = <App />;
    root.render(
      <React.StrictMode>
        {sentryEnabled ? (
          <Sentry.ErrorBoundary fallback={<FriendlyErrorFallback />} showDialog={false}>
            {app}
          </Sentry.ErrorBoundary>
        ) : (
          app
        )}
      </React.StrictMode>
    );
  });
